module.exports = __webpack_public_path__ + "img/Edit.9a061de3.png";